import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyD6NibK82H_3qAqLhkgY0gUsEteCRVXGyc",
  authDomain: "raspyy-portfolio.firebaseapp.com",
  databaseURL: "https://raspyy-portfolio-default-rtdb.firebaseio.com",
  projectId: "raspyy-portfolio",
  storageBucket: "raspyy-portfolio.appspot.com",
  messagingSenderId: "47916938519",
  appId: "1:47916938519:web:7bbf51b2e8a32f803bb352"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
